export const MANAGER_ROLES = {
  admin: 'admin',
  payerSupport: 'payer_support',
  translator: 'translator',
  accountant: 'accountant',
}
